<template> 
    <v-sheet tile  
 style="height: 300px; color:white; background-size:cover; background-image: linear-gradient(to top, rgba(13, 3, 29, 0.6), rgba(25, 25, 38, 0.6)), url(&quot;https://pub.sum.ba/registar_radova.jpg&quot;); background-position: center center; ">
        <v-container>
          <div
            align="center"
            justify="center"
            class="col"
            style="transform-origin: center top 0px;"
          >
            <svgicon
            class="mt-8"
              icon="sum-icon"
              height="80px"
              width="100px"
              color="white white white white white red white white"
            ></svgicon>
            <p class="mb-2 text-header" :style="getDeviceType!='touch'?'font-size:40px':'font-size:20px'">Registar Sveučilišta u Mostaru</p>
            <div
              :class="getDeviceType!='touch'?'title font-weight-light':'font-weight-light'"
            >Admin panel objavljenih radova akademskog osoblja Sveučilišta i cjelovitih tekstova obranjenih doktorskih radova</div>
          </div>
        </v-container>
    </v-sheet>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  computed:{
    ...mapGetters(["getDeviceType"]),
  }
}
</script>